import request, { get, post } from '@/utils/request'
import { invokeApi } from '@/utils/shared'

export function getHospitalInfo() {
  return request({
    url: '/system/basic/getHospitalInfo',
    method: 'post',
  })
}
//获取科室列表
export function getDepartmentList(params) {
  return request({
    url: '/system/basic/getDepartmentList',
    method: 'post',
    params
  })
}
//添加科室
export function addDepartment(params) {
  return request({
    url: '/system/basic/addDepartment',
    method: 'post',
    params
  })
}
//修改科室
export function updateDepartment(params) {
  return request({
    url: '/system/basic/updateDepartment',
    method: 'post',
    params
  })
}
//
export function deleteDepartment(params) {
  return request({
    url: '/system/basic/deleteDepartment',
    method: 'post',
    params
  })
}
//绑定配置量表
export function bindScale(data) {
  return request({
    url: '/system/basic/BindScale',
    method: 'post',
    data
  })
}
//获取配置量表列表
export function getScaleSort(params) {
  return request({
    url: '/system/basic/getScaleSort',
    method: 'post',
    params
  })
}
//获取职位列表
export function getPositionList(data) {
  return request({
    url: '/system/basic/getPositionList',
    method: 'post',
    data
  })
}
//添加职位
export function addPosition(params) {
  return request({
    url: '/system/basic/addPosition',
    method: 'post',
    params
  })
}
//删除职位
export function deletePosition(params) {
  return request({
    url: '/system/basic/deletePosition',
    method: 'post',
    params
  })
}
//修改职位
export function upDatePosition(params) {
  return request({
    url: '/system/basic/upDatePosition',
    method: 'post',
    params
  })
}


//获取员工列表
export function getStaffList(data) {
  return request({
    url: '/system/basic/getStaffList',
    method: 'post',
    data
  })
}
//添加员工
export function addStaff(data) {
  return request({
    url: '/system/basic/addStaff',
    method: 'post',
    data
  })
}
//设置操作员
export function setOperate(params) {
  return request({
    url: '/system/basic/setOperate',
    method: 'post',
    params
  })
}
//移除操作员
export function removeOperate(params) {
  return request({
    url: '/system/basic/removeOperate',
    method: 'post',
    params
  })
}
//删除员工
export function deleteOperate(params) {
  return request({
    url: '/system/basic/deleteOperate',
    method: 'post',
    params
  })
}
//修改员工
export function updateStaff(data) {
  return request({
    url: '/system/basic/updateStaff',
    method: 'post',
    data
  })
}
//获取全部科室列表
export function getDepartment(params) {
  return request({
    url: '/system/basic/getDepartment',
    method: 'post',
    params
  })
}

/** 获取协议列表 */
export function getProtocolList(data) {
  return get("/api/sign/getAgreement", data)
}

/** 获取协议详情 */
export function getProtocolById(id) {
  return get("/api/sign/agreement", { id })
}

/** 新增修改协议 */
export function addOrEditProtocal(data) {
  return post("/api/sign/addAgreement", data)
}

/** 标签 */
export const getTags = d => post("/system/label/getLabelList", d)
export const delTag = labelCode => post("/system/label/deletedLabel", { labelCode })
export const addTag = d => post("/system/label/addLabel", d)
/** 获取标签(病种)选项 */
export const getTagOpts = async () => {
  const res = await invokeApi(getTags, {
    pageNum: 1,
    pageSize: 9999,
  })
  return res.data.list.map(it => {
    return { label: it.labelName, value: it.labelName }
  })
}

export const getQuestionByTagId = labelId => get("/system/selfScale/getSfSelfDetail", { labelId })

export const getQuestionRecord = id => get("/system/selfScale/getWjSfDetail", { id })

/** 病种分类 */
export const getDiseaseClass = d => post("/system/disKno/getDisSort", d)
export const delDiseaseClass = id => get("/system/disKno/deleteDisSort", { id })
export const addDiseaseClass = d => post("/system/disKno/addDisSort", d)

/** 病种 */
export const getDiseases = d => post("/system/disKno/getDis", d)
export const delDisease = id => get("/system/disKno/deleteDis", { id })
export const addDisease = d => post("/system/disKno/addDis", d)

/** 获取指标 */
export const getIdxs = d => get("/system/disKno/getScaleZb", {})

export const setDiseaseTelTpl = d => post("/system/label/setConfig", d)

export const setMsgTpl = d => post("/system/label/setShortMessage", d)
export const sendMsg = d => post("/system/label/setSfShortRecord", d)
export const disableMsgTpl = d => get("/system/label/userOrNo", d)
export const disableQuestionTpl = d => get("/system/label/userOrNo", d)
export const disableTelTpl = d => get("/system/label/userOrNo", d)
export const msgRecords = d => post("/system/label/getShortRecord", d)











